export default __webpack_public_path__ + "static/media/151-mechanics.8a09d5c7.png";